
import { Component, Vue } from 'vue-property-decorator';

import Navbar from '@/components/Navbar.vue';
import Sidebar from '@/components/Sidebar.vue';

@Component({
  components: {
    Navbar,
    Sidebar,
  },
})
export default class AuthenticatedRoute extends Vue {
}
